/*
 * Copyright (c) Nexign, JSC, 2021-2024.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.30.0
 * @since 1.13.0
 */

import styled from 'styled-components';

import { colors, fonts } from '@theme/index';

export const SubscriberIdFinancesPreliminaryDataContainer = styled.div`
    margin-bottom: 24px;
`;

export const SubscriberIdFinancesStyled = styled.div.attrs({
    className: 'subscriber-id-finances',
})`
    .subscriber-id-finances__title {
        margin-bottom: 16px;
    }

    .subscriber-id-finances__total {
        display: flex;
        justify-content: space-between;
        margin-right: 24px;
        ${fonts.textMainBold};
        margin-bottom: 4px;
    }

    .subscriber-id-finances__date {
        color: ${colors.textColorOpacity};
    }

    .subscriber-id-finances__warning {
        margin-top: 16px;
    }

    .subscriber-id-finances__btn {
        margin-top: 32px;
        display: block;

        backface-visibility: hidden;
    }

    .chart-pie .legend-with-children,
    .subscriber-id-finances__title {
        width: 400px;
    }

    .chart-pie {
        flex-direction: row-reverse;
        justify-content: space-around;
        align-items: flex-start;

        .chart-pie__diagram {
            margin: 0 100px;
        }

        .legend-with-children {
            margin-top: 0;
        }

        .legend {
            .legend__name {
                max-width: 270px;
            }
        }
    }
`;

export const SubscriberIdFinancesEmptyStyled = styled.div.attrs({
    className: 'subscriber-id-finances_empty',
})`
    display: flex;
    flex-direction: column;
    align-items: center;

    .finance-empty__title {
        ${fonts.textMainBold};
        margin-top: 16px;
    }
`;
